import React, { useState } from 'react';
import { ReactComponent as PublishedIndicator } from '../../../../assets/images/published-indicator.svg';
import CollapseSection from '../components/CollapseSection';
import PublishedDashboards from './PublishedDashboards';
import PublishedDashboardActions from './PublishedDashboardActions';
import { DashboardNavSectionType } from '../../types';
import useDashboardSelector from '../../../../redux/selectorHooks/useDashboardSelector';
import useRefetchPublishedFolder from './utils/useRefetchPublishedFolder';

const PublishedDashboardsController = () => {
  const publishedFolder = useDashboardSelector('publishedFolder');

  useRefetchPublishedFolder();

  const [createFolderMode, setCreateFolderMode] = useState(false);

  if (!publishedFolder) {
    return null;
  }

  const { path, subFolders, templates } = publishedFolder;

  if (!path.length && !subFolders.length && !templates.length) {
    return null;
  }

  return (
    <CollapseSection
      variant={DashboardNavSectionType.Published}
      title={'Published'}
      headerComponent={<PublishedIndicator width={16} height={16} />}
      actions={
        <PublishedDashboardActions
          path={path}
          onCreateFolder={() => setCreateFolderMode(true)}
        />
      }
    >
      <PublishedDashboards
        publishedFolder={publishedFolder}
        createFolderMode={createFolderMode}
        setCreateFolderMode={setCreateFolderMode}
      />
    </CollapseSection>
  );
};

export default PublishedDashboardsController;
